export const STORAGE_KEY = "used-car-lead-intake-v2";
export const LEAD_DESK_STAGE = "Lead Intake";
export const INSPECTION_QUEUE_STAGE = "Inspection Queue";
export const COLUMN_PAGE_SIZE = 20;

export const PIPELINE_COLUMNS = [
  { key: "New",                  label: "New",        color: "#475569", bg: "#f8fafc", border: "#cbd5e1" },
  { key: "Not Answered",         label: "Not Ans.",   color: "#ea580c", bg: "#fff7ed", border: "#fed7aa" },
  { key: "Connected",            label: "Connected",  color: "#2563eb", bg: "#eff6ff", border: "#bfdbfe" },
  { key: "Callback Scheduled",   label: "Callback",   color: "#ca8a04", bg: "#fefce8", border: "#fef08a" },
  { key: "Qualified",            label: "Qualified",  color: "#16a34a", bg: "#f0fdf4", border: "#bbf7d0" },
  { key: "Inspection Scheduled", label: "Inspection", color: "#7c3aed", bg: "#f5f3ff", border: "#ddd6fe" },
  { key: "Closed",               label: "Closed",     color: "#dc2626", bg: "#fef2f2", border: "#fecaca" },
];

export const LEAD_STATUS_OPTIONS = PIPELINE_COLUMNS.map((c) => c.key);

export const CLOSURE_REASONS = [
  "Not interested",
  "Price mismatch",
  "Already sold",
  "Wrong lead",
  "No response",
  "Duplicate",
];

export const SAMPLE_LEADS = [
  {
    id: "UL-2401",
    name: "Rohit Kumar",
    mobile: "98XXXX1123",
    address: "Central Delhi, New Delhi",
    leadDate: "04 Apr 2025",
    leadId: "C2B-100421",
    make: "Hyundai",
    model: "Grand i10",
    variant: "Sportz 1.2 VTVT",
    mfgYear: "2018",
    color: "Sleek Silver",
    mileage: "54000",
    fuel: "Petrol",
    regNo: "DL8CAF1254",
    ownership: "1st",
    insurance: "Valid",
    insuranceCategory: "",
    hypothecation: null,
    bankName: "",
    accidentPaintHistory: null,
    accidentPaintNotes: "",
    source: "CarWale",
    expectedPrice: 425000,
    updatedExpectedPrice: null,
    status: "New",
    pipelineStage: LEAD_DESK_STAGE,
    assignedTo: "Aviral",
    nextFollowUp: null,
    inspectionScheduledAt: null,
    closureReason: "",
    notes: "Fresh inbound lead from CarWale export.",
    activities: [
      {
        id: "a1",
        type: "lead-imported",
        title: "Lead imported",
        detail: "Imported from marketplace.",
        at: "2025-04-04T10:00:00.000Z",
      },
    ],
  },
  {
    id: "UL-2402",
    name: "Tarun Sharma",
    mobile: "98XXXX6631",
    address: "South Delhi, New Delhi",
    leadDate: "04 Apr 2025",
    leadId: "C2B-100422",
    make: "Maruti Suzuki",
    model: "S Cross",
    variant: "Alpha DDiS 320",
    mfgYear: "2019",
    color: "Pearl Arctic White",
    mileage: "68000",
    fuel: "Diesel",
    regNo: "DL3CCB9981",
    ownership: "2nd",
    insurance: "Expired",
    insuranceCategory: "Expired",
    hypothecation: null,
    bankName: "",
    accidentPaintHistory: null,
    accidentPaintNotes: "",
    source: "CarTrade",
    expectedPrice: 635000,
    updatedExpectedPrice: null,
    status: "Callback Scheduled",
    pipelineStage: LEAD_DESK_STAGE,
    assignedTo: "Tarun",
    nextFollowUp: "2026-04-09T12:30:00.000Z",
    inspectionScheduledAt: null,
    closureReason: "",
    notes: "Seller wants a noon callback after discussing with family.",
    activities: [
      {
        id: "a2",
        type: "lead-imported",
        title: "Lead imported",
        detail: "Imported from marketplace.",
        at: "2025-04-04T10:00:00.000Z",
      },
      {
        id: "a3",
        type: "call-log",
        title: "Callback scheduled",
        detail: "Follow-up after 12:30 PM.",
        at: "2026-04-09T09:15:00.000Z",
      },
    ],
  },
  {
    id: "UL-2403",
    name: "Harish Verma",
    mobile: "98XXXX7721",
    address: "West Delhi, New Delhi",
    leadDate: "04 Apr 2025",
    leadId: "C2B-100423",
    make: "Hyundai",
    model: "i20",
    variant: "Sportz 1.4 AT",
    mfgYear: "2020",
    color: "White",
    mileage: "32000",
    fuel: "Petrol",
    regNo: "HR26EM2201",
    ownership: "1st",
    insurance: "Valid",
    insuranceCategory: "",
    hypothecation: false,
    bankName: "",
    accidentPaintHistory: false,
    accidentPaintNotes: "",
    source: "CarWale",
    expectedPrice: 735000,
    updatedExpectedPrice: null,
    status: "Inspection Scheduled",
    pipelineStage: INSPECTION_QUEUE_STAGE,
    assignedTo: "Deepak",
    nextFollowUp: null,
    inspectionScheduledAt: "2026-04-10T14:30:00.000Z",
    closureReason: "",
    notes: "Qualified lead moved to inspection queue.",
    activities: [
      {
        id: "a4",
        type: "lead-imported",
        title: "Lead imported",
        detail: "Imported from marketplace.",
        at: "2025-04-04T10:00:00.000Z",
      },
      {
        id: "a5",
        type: "inspection",
        title: "Inspection scheduled",
        detail: "10 Apr 2026, 02:30 PM.",
        at: "2026-04-09T10:20:00.000Z",
      },
    ],
  },
  {
    id: "UL-2404",
    name: "Priya Mehta",
    mobile: "97XXXX3344",
    address: "Noida, UP",
    leadDate: "05 Apr 2025",
    leadId: "C2B-100424",
    make: "Honda",
    model: "City",
    variant: "V CVT",
    mfgYear: "2021",
    color: "Golden Brown",
    mileage: "28000",
    fuel: "Petrol",
    regNo: "UP16AT4421",
    ownership: "1st",
    insurance: "Valid",
    insuranceCategory: "Comprehensive",
    hypothecation: true,
    bankName: "HDFC Bank",
    accidentPaintHistory: false,
    accidentPaintNotes: "",
    source: "OLX",
    expectedPrice: 950000,
    updatedExpectedPrice: 910000,
    status: "Qualified",
    pipelineStage: LEAD_DESK_STAGE,
    assignedTo: "Aviral",
    nextFollowUp: "2026-04-11T10:00:00.000Z",
    inspectionScheduledAt: null,
    closureReason: "",
    notes: "Very motivated seller. Wants quick deal.",
    activities: [
      {
        id: "a6",
        type: "lead-imported",
        title: "Lead imported",
        detail: "Added manually.",
        at: "2025-04-05T09:00:00.000Z",
      },
      {
        id: "a7",
        type: "call-log",
        title: "Connected",
        detail: "Good conversation. Seller motivated.",
        at: "2026-04-08T11:30:00.000Z",
      },
    ],
  },
  {
    id: "UL-2405",
    name: "Vikram Singh",
    mobile: "96XXXX8899",
    address: "Gurgaon, Haryana",
    leadDate: "03 Apr 2025",
    leadId: "C2B-100425",
    make: "Tata",
    model: "Nexon",
    variant: "XZ Plus Dark EV",
    mfgYear: "2022",
    color: "Magnetic Red",
    mileage: "19000",
    fuel: "Electric",
    regNo: "HR26BE9910",
    ownership: "1st",
    insurance: "Valid",
    insuranceCategory: "Zero-Dep",
    hypothecation: null,
    bankName: "",
    accidentPaintHistory: null,
    accidentPaintNotes: "",
    source: "Cars24",
    expectedPrice: 1250000,
    updatedExpectedPrice: null,
    status: "Not Answered",
    pipelineStage: LEAD_DESK_STAGE,
    assignedTo: "Tarun",
    nextFollowUp: "2026-04-09T15:00:00.000Z",
    inspectionScheduledAt: null,
    closureReason: "",
    notes: "No pick on 2 attempts. Will try again.",
    activities: [
      {
        id: "a8",
        type: "lead-imported",
        title: "Lead imported",
        detail: "Imported.",
        at: "2025-04-03T08:00:00.000Z",
      },
    ],
  },
];
